// Links from the admin inspector into Sentry, and the room id that makes them
// possible.
//
// Kept apart from config/sentry.ts because that module calls Sentry.init on
// import, so a test cannot load it.

const SENTRY_ORG_URL = 'https://breakout-learning.sentry.io'
const SENTRY_PROJECT_SLUG = 'cases-react'
const SENTRY_PROJECT_ID = '4507176853504000'

// Sentry's issues list defaults to 14 days, too short for a room someone is
// looking into weeks later.
const ROOM_ISSUES_STATS_PERIOD = '90d'

// `/meeting/<id>` and the pages under it, such as
// `/meeting/<id>/duplicate-error`, and `/demo/meeting/<id>`, the demo waiting
// room for the same room.
const MEETING_PATH = /^\/(?:demo\/)?meeting\/([^/]+)(?:\/|$)/

// The room id from a Sentry event's `request.url`, when the event came from
// `/meeting/<roomId>`, a page under it, or `/demo/meeting/<roomId>`. Undefined
// for every other page, and for a missing or unparseable URL.
export function roomIdFromSentryUrl(url: string | undefined) {
  if (!url) return undefined

  let pathname: string
  try {
    // URL drops `?…` and `#…` from pathname.
    pathname = new URL(url).pathname
  } catch {
    return undefined
  }

  const match = MEETING_PATH.exec(pathname)
  if (!match) return undefined

  // A bad escape like `%zz` survives URL parsing but makes decodeURIComponent
  // throw, and a throw here would drop the event from beforeSend.
  try {
    return decodeURIComponent(match[1])
  } catch {
    return undefined
  }
}

export function sentryEventUrl(eventId: string) {
  return `${SENTRY_ORG_URL}/organizations/breakout-learning/projects/${SENTRY_PROJECT_SLUG}/events/${encodeURIComponent(eventId)}/`
}

export function sentryRoomIssuesUrl(roomId: string) {
  const params = new URLSearchParams({
    project: SENTRY_PROJECT_ID,
    // The wildcard also matches `/demo/meeting/<id>`, the room's demo
    // waiting room.
    query: `url:*meeting/${roomId}*`,
    statsPeriod: ROOM_ISSUES_STATS_PERIOD,
  })
  return `${SENTRY_ORG_URL}/issues/?${params.toString()}`
}
